import { KursyDoradcaList } from "./doradca";
import { KursyRachunkowoscList } from "./kurs-rachunkowosc";
import { KursyPopList } from "./pop";

export type KursCategory = "rachunkowosc" | "doradca-podatkowy" | "pit" | "cit" | "cit-eston" | "podstawy-prawa-podatkowego" | "kontrole-postep" | "vat" | "podatki-od-podstaw" | "zus" | "pkpir" | null;

export interface Kurs {
	slug: string;
	title: string;
	description: string;
	category: KursCategory;
	level: "podstawa" | "rozszerzenie" | "generalny" | null;
	productId: number | null;
}

export const KursyGeneralList: Array<Kurs> = [
	{
		slug: "kurs-rachunkowosc",
		title: "Kurs rachunkowość od podstaw",
		description:
			"Praktyczny kurs, który w krótkim czasie wyposaży Cię w wiedzę i umiejętności potrzebne do swobodnej pracy w świecie księgowości i finansów.",
		category: "rachunkowosc",
		level: "generalny",
		productId: null,
	},
	{
		slug: "kurs-doradca-podatkowy",
		title: "Kurs Doradca Podatkowy",
		description:
			"Kompleksowy kurs, który przygotuje Cię do egzaminu ustnego i pisemnego na Doradcę Podatkowego. Oparty na realnych pytaniach i przykładach.",
		category: "doradca-podatkowy",
		level: "generalny",
		productId: null,
	},
	{
		slug: "pop",
		title: "Kurs podatki od podstaw",
		description: "",
		category: "podatki-od-podstaw",
		level: "generalny",
		productId: null,
	},
];

export const KursPkpir: Kurs = {
	slug: "kurs_pkpir",
	title: "Podatkowa Księga Przychodów i Rozchodów",
	description:
		"Podczas kursu nauczysz się, jak prowadzić PKPiR bez zbędnych komplikacji, ewidencjonować przychody i koszty oraz rozliczać VAT bez stresu.",
	level: null,
	category: "pkpir",
	productId: null,
};

export const kursyAll = [
	...KursyRachunkowoscList,
	...KursyDoradcaList,
	...KursyPopList,
	KursPkpir,
];